import { isObject } from '@iconik-io/core/src/is_object';

import type { FacetBucketSchema } from '../types/common';

const readBuckets = (facet: unknown): FacetBucketSchema[] | undefined => {
  if (!isObject(facet) || !Array.isArray(facet.buckets)) {
    return undefined;
  }
  return facet.buckets.filter(
    (bucket): bucket is FacetBucketSchema =>
      isObject(bucket) && typeof bucket.key === 'string',
  );
};

/**
 * Aggregations come back as a bag of unknowns, so the one facet a caller wants
 * is checked rather than assumed. The current filter selection is preferred
 * over the unfiltered aggregation, which is what the endpoint returns
 * alongside it.
 */
export const readFacetBuckets = (
  facets: unknown,
  name: string,
): FacetBucketSchema[] => {
  if (!isObject(facets)) {
    return [];
  }
  const selected = isObject(facets.current_facet_filters)
    ? readBuckets(facets.current_facet_filters[name])
    : undefined;
  return selected ?? readBuckets(facets[name]) ?? [];
};
